export const formatRequiredLabel = (label, required) =>
  required ? `${label}*` : label;
